import React from "react";
import { Link } from "react-router-dom";
import { Type } from "@ebscois/react-component-library";
import { StyledAnchor } from "./_styled";
import { logTopicInDepthAnswersClicked } from "../../../util/analytics";

const useDrugMappingProcessor = function ({
  slugPubType,
  slugTitle,
  telemetryData,
}) {
  const processMappingLinks = (options) => {
    const { node } = options;
    const sectionId = node.attribs["data-href"];
    const href = `/${slugPubType}/${slugTitle}/details/${sectionId}`;
    return (
      <>
        <Type element="i">See corresponding </Type>

        <StyledAnchor
          linkComponent={Link}
          fontWeight="semibold"
          href={href}
          onClick={() => {
            logTopicInDepthAnswersClicked(telemetryData);
          }}
        >
          In-Depth Answers
        </StyledAnchor>
      </>
    );
  };

  return { processMappingLinks };
};

export default useDrugMappingProcessor;
